// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout_main__0_AIL","body":"Layout_body__zC_hG"};